import React from 'react';

const VisorImagenModal = ({ isOpen, onClose, imageUrl }) => {
  if (!isOpen) {
    return null;
  }

  return (
    <div
      className="fixed inset-0 bg-black bg-opacity-75 flex justify-center items-center z-50"
      onClick={onClose}
      aria-modal="true"
      role="dialog"
    >
      <div
        className="relative bg-white p-4 rounded-lg max-w-4xl w-11/12 max-h-[95vh] shadow-2xl"
        onClick={(e) => e.stopPropagation()}
      >
        <button
          onClick={onClose}
          className="absolute -top-3 -right-3 text-white bg-gray-700 rounded-full h-8 w-8 flex items-center justify-center text-lg leading-none hover:bg-gray-900 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-gray-500 z-10"
          aria-label="Cerrar"
        >
          &times;
        </button>
        <div className="overflow-auto max-h-[calc(95vh-2rem)]">
          <img 
            src={imageUrl} 
            alt="Vista ampliada de la factura" 
            className="w-full h-auto object-contain"
          />
        </div>
      </div>
    </div>
  );
};

export default VisorImagenModal;
